/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSsmCommandInstanceExecutionBatchResponse {
    getFixupPrototypeFunction() { return AwsSsmCommandInstanceExecutionBatchResponse.fixupPrototype; }

    static newInstance(model: Partial<AwsSsmCommandInstanceExecutionBatchResponse>): AwsSsmCommandInstanceExecutionBatchResponse {
        let obj = Object.assign(new AwsSsmCommandInstanceExecutionBatchResponse(), model);
        AwsSsmCommandInstanceExecutionBatchResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSsmCommandInstanceExecutionBatchResponse>): AwsSsmCommandInstanceExecutionBatchResponse {
        if (!model) return null;
        return AwsSsmCommandInstanceExecutionBatchResponse.newInstance(<AwsSsmCommandInstanceExecutionBatchResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSsmCommandInstanceExecutionBatchResponse) {
        if (!obj) return;

        models.AwsSsmCommandInstanceExecutionBatchResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSsmCommandInstanceExecutionBatchResponse): boolean {
        Object.setPrototypeOf(obj, AwsSsmCommandInstanceExecutionBatchResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.results) {
            for (let key in this.results) {
                let val = this.results[key];
                if (val) {
                    models.AwsSsmCommandInstanceExecutionDetail.fixupPrototype(val);
                }
            }
        }
    }

    /**
     * Map from identifier to response model
     */
    results: { [key: string]: models.AwsSsmCommandInstanceExecutionDetail; };

}
